import { MarkedText } from '../../components/common/atoms'
import { pencil_icon } from '../../assets/images'

const updateTableSchema = [
  {
    title: 'EMPLOYEE NAME',
    dataIndex: 'name',
    key: 'name',
    render: (name) => <span style={{ fontSize: '14px', fontWeight: '600' }}>{name}</span>,
    width: '17%',
  },
  {
    title: 'EMPLOYEE ID',
    dataIndex: 'employee_id',
    key: 'id',
    width: '17% ',
  },
  {
    title: 'MOBILE NUMBER',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    width: '17%',
  },
  {
    title: 'EMAIL',
    dataIndex: 'email',
    key: 'email',
    width: '22%',
  },
  {
    title: 'STATUS',
    dataIndex: 'customer_status',
    key: 'status',
    render: (customer_status) => <MarkedText flag={customer_status === 'Active'}>{customer_status}</MarkedText>,
    width: '17%',
  },
  {
    key: 'edit',
    dataIndex: '',
    render: (record) => (
      <img
        src={pencil_icon}
        alt='edit icon'
        style={{ cursor: 'pointer' }}
        onClick={(event, id = record.id) => {
          record.handler(record)
        }}
      />
    ),
    width: '8%',
  },
]

export default updateTableSchema